import React from 'react'

import styles from './UsageTableFooter.module.scss'

interface UsageTableFooterProps {
  overallLabel: string
  overallValue?: string
}

export default function UsageTableFooter({
  overallLabel,
  overallValue,
}: UsageTableFooterProps) {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.headerRow}>
          <div className={styles.overallLabel}>
            <div className={styles.labelText}>
              <p>Overall</p>
            </div>
          </div>
          <div className={styles.percentageLabel}>
            <p>Percentage</p>
          </div>
        </div>
        <div className={styles.dataRow}>
          <div className={styles.overallLabel}>
            <div className={styles.labelText}>
              <p>{overallLabel}</p>
            </div>
          </div>
          <div className={styles.percentageValue}>
            <p>{overallValue}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
